import { getApiBase } from "../utils/apiBase";
import Cookies from "js-cookie";

import { ApiError } from "../types/api";


export interface ExportMitigationStrategyZipParams {
  projectId: number;
  strategyId: string;
}

export interface ExportMitigationStrategyZipResult {
  blob: Blob;
  filename: string;
}

const parseFilename = (contentDisposition: string | null): string => {
  if (!contentDisposition) return "mitigation_strategy_treatments.zip";
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  if (match && match[1]) return match[1];
  return "mitigation_strategy_treatments.zip";
};

export const exportMitigationStrategyZip = async (
  params: ExportMitigationStrategyZipParams,
): Promise<ExportMitigationStrategyZipResult> => {
  const { projectId, strategyId } = params;

  const csrfToken = Cookies.get("csrftoken") || "";
  const response = await fetch(
    `${getApiBase()}/api/projects/${projectId}/mitigationStrategies/${strategyId}/export`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "X-CSRFToken": csrfToken,
      },
    },
  );

  if (!response.ok) {
    const errorData = await response
      .json()
      .catch(() => ({ message: "Failed to export strategy" }));

    const apiError: ApiError = {
      message: errorData?.message || "Failed to export strategy",
      status: response.status,
    };

    throw apiError;
  }

  const filename = parseFilename(response.headers.get("Content-Disposition"));
  const blob = await response.blob();
  return { blob, filename };
};
